/* eslint-disable no-console */
import { TextError } from '../types/TextError.js';

export class SpellCheckerService {
  private readonly BASE_URL = '/api/index.php';
  // private readonly BASE_URL = 'https://sinonimos-br.test/api/index.php';

  async checkText(
    text: string,
    language: string,
    recheck: boolean = false,
  ): Promise<TextError[]> {
    try {
      const payload: Record<string, any> = { text, language };

      if (recheck) {
        payload.recheck = true;
      }

      const response = await fetch(`${this.BASE_URL}?method=getspellchecker`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      return data.errors || [];
    } catch (error) {
      console.error('API request failed:', error);
      return [];
    }
  }

  async rewriteText(text: string, language: string): Promise<string> {
    try {
      const response = await fetch(
        `${this.BASE_URL}?method=getRewrittenTextWithoutErrors`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ text, language }),
        },
      );

      const data = await response.json();
      return data.data?.rewritten_text || text;
    } catch (error) {
      console.error('API rewrite request failed:', error);
      return text;
    }
  }
}
